import { FileDown } from "lucide-react";
import { api } from "@/lib/api";
import { ActionButton, saveBlob, blobError } from "./kit";

const AREAS = [["all", "Alle Bereiche"], ["auth", "Anmeldung"], ["members", "Mitglieder"], ["reviews", "Profilprüfungen"],
  ["activities", "Aktivitäten"], ["groups", "Kreise"], ["reports", "Meldungen"], ["support", "Support"], ["content", "Inhalte"],
  ["notifications", "Benachrichtigungen"], ["system", "System"], ["member_app", "Mitglieder-App"]].map(([value, label]) => ({ value, label }));

export function AuditExport() {
  const today = new Date().toISOString().slice(0, 10);
  return (
    <ActionButton label="Audit-Export" icon={FileDown} testId="audit-export"
      page="export" title="Audit-Export begründen" pageSubtitle="Begründe Zeitraum und Umfang des angeforderten Audit-Exports." submitLabel="Export erstellen"
      description="Exportiert nur Metadaten (keine Inhalte, keine Passdaten). Der Export selbst wird als Warnereignis protokolliert."
      fields={[
        { name: "date_from", label: "Von", type: "date", required: true },
        { name: "date_to", label: "Bis", type: "date", required: true, default: today },
        { name: "area", label: "Bereich", type: "select", options: AREAS, default: "all", placeholder: false },
        { name: "purpose", label: "Zweck des Exports", type: "textarea", required: true },
        { name: "include_actor_email", label: "Konto-E-Mail der handelnden Person einschließen", type: "checkbox" },
      ]}
      onSubmit={async (v) => {
        try {
          const res = await api.post("/audit-export", v, { responseType: "blob" });
          saveBlob(res.data, `audit-export-${v.date_from}-${v.date_to}.csv`);
          return "Audit-Export erstellt.";
        } catch (err) {
          throw await blobError(err);
        }
      }} />
  );
}
